import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Navigate } from 'react-router-dom';
import MainNavbar from '../MainNavbar/MainNavbar';
import Footer from '../Footer/Footer';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import { Box, Container, Paper, Typography } from '@mui/material';
import styles from './AdminLayout.module.css';

const AdminLayout: React.FC = () => {
  const { breadcrumbs, breadcrumbActions } = useBreadcrumb();
  const { user } = useSelector((state: RootState) => state.user);

  // Redirect if not admin
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.layout}>
      <MainNavbar />
      <main className={styles.content}>
        <Container maxWidth="lg">
          <Box sx={{ my: 4 }}>
            {breadcrumbs.length > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                }}
              >
                <Breadcrumb items={breadcrumbs} sx={{ mt: 2, mb: 0 }} />
                {breadcrumbActions && <Box sx={{ mt: 2 }}>{breadcrumbActions}</Box>}
              </Box>
            )}
            <Outlet />
          </Box>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default AdminLayout;
